"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _reactRhumb = require("react-rhumb");

var _UIAlert = _interopRequireDefault(require("UIComponents/alert/UIAlert"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var FailedLoadBanner = function FailedLoadBanner(_ref) {
  var hasFailed = _ref.hasFailed;

  if (hasFailed) {
    return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_reactRhumb.NavMarker, {
      name: "FAILED_LOAD_BANNER"
    }), _react.default.createElement(_UIAlert.default, {
      titleText: _react.default.createElement(_FormattedMessage.default, {
        message: "failedLoadBanner.title"
      }),
      type: "danger",
      className: "m-bottom-4"
    }, _react.default.createElement(_FormattedMessage.default, {
      message: "failedLoadBanner.description"
    })));
  }

  return null;
};

FailedLoadBanner.propTypes = {
  hasFailed: _propTypes.default.bool
};
FailedLoadBanner.defaultProps = {
  hasFailed: false
};
var _default = FailedLoadBanner;
exports.default = _default;
module.exports = exports.default;